<template>
    <modal name="member-active-modal" class="member-out-modal member-active-modal"
           :width="'30%'"
           :height="'auto'"
           @before-close="initData"
    >
        <div class="keymodal_title">
      <span class="keymodal_title_txt">
      </span>
          <div class="out_title">사용자 이용정지 해제</div>

            <!-- <button class="keymodal_title_btn" @click="closeModal">
                <i class="el-dialog__close el-icon el-icon-close"></i>
            </button> -->
        </div>
        <div class="pb30">
            <div class="c_table_wrap pt40 text_center">
                <div class="">
                    <p class="fs16 mb10">해당 사용자의 이용정지를 해제합니다.</p>
                </div>
                <div class="text_left out_table">
                    <el-input class=" mt3" type="password" v-model="mb_password" placeholder="관리자 비밀번호"></el-input>
                    <div class="input_error">{{validation.firstError('mb_password') }}</div>

                </div>
            </div>
            <div class="text_center pt50">
                <el-button type="info" class="out_btn" @click="closeModal()">취소</el-button>
                <el-button type="info" class="out_btn" @click="memberActive()">확인</el-button>
            </div>
          </div>
    </modal>
</template>

<script>
    import VuxAlert from '@/mixins/alertMixins';
    import AuthValidator from "@/mixins/validators/AuthValidator";

    let params = {};
    export default {
        name: "MemberActiveModal",
        mixins: [ VuxAlert ,AuthValidator],
        inject: [],
        props: {
            getObj: {},
            afterFunc: {default: () => {}},
        },
        data() {
            return {
                outList : []
            }
        },
        methods: {
            initData() {
                this.mb_password = '';
            },
            memberActive() {
                let validationArray = ['mb_password'];
                this.$validate(validationArray).then(async (success) => {
                    if(success) {
                        params = {
                            mb_no : this.getObj.mb_no,
                            mb_password : this.mb_password,
                        }

                        this.$api.$member.activeMember(params).then( res => res.Data.Result).then(res => {
                            let type = this.returnType(res.Info.Type);
                            if(type != true) {
                                this.errorAlert(type);
                                return;
                            }
                            this.createAlert({
                                title: '',
                                content: '이용제한 해제처리 되었습니다.',
                                btnText: '확인',
                                hide: () => {
                                    /*if(this.memberWriteSetData) {
                                        this.memberWriteSetData('isStopUser', 0);
                                    }*/
                                    this.afterFunc();
                                    this.closeModal();
                                },
                            })
                        })
                    }else{
                        this.errorAlert('입력값을 확인해주세요.')
                    }
                });
            },
            returnType(type) {
                switch (type) {
                    case 1:
                        return true;
                    case -2:
                        return '권한이 없습니다.';
                    case -5:
                        return '이미 해제된 회원이거나 탈퇴회원입니다.';
                    case -200:
                        return '관리자의 비밀번호가 맞지않습니다.';
                    default:
                        return '회원 이용제한 해제에 실패하였습니다. 잠시후 다시 시도해주세요.';
                }
            },
            closeModal() {
                this.$modal.hide("member-active-modal")
            },
        }
    }
</script>

<style scoped>

</style>
